export enum EventCategory {
  BROADCAST = "BROADCAST",
  SHOWCASE = "SHOWCASE",
  CONCERT = "CONCERT",
  FANMEETING = "FANMEETING",
  FANSIGN = "FANSIGN",
  ETC = "ETC",
}
